import { NavigateFunction } from 'react-router-dom';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { EditType } from '../BookingDetailedView';
import {
	checkBookingCanBeModified,
	discardAlterations,
} from 'Services/Api/_HumanWritten/BookingService/FerryTripBookingService';
import { BookingEntity } from 'Models/Entities';
import { ProcessResults } from './EditCancelPopUp';
import {
	clearEventBookingWizardData,
	clearOldEventBookingWizardData,
	saveEventBookingWizardDataToLocalStorage,
	saveOldEventBookingWizardData,
} from 'Views/Components/_HumanWritten/BookingWizard/EventsBookingWizard/EventsBookingWizardData';
import { convertEventBookingToWizardData } from 'Util/_HumanWritten/BookingWizard/EventBookingToWizardDataUtils';
import { clearEventBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';
import { cloneDeep } from 'lodash';

export type EventEditType = 'event-date-time' | 'event-contact' | 'tickets' | 'event-details';

export const onEventEdit = async (navigate: NavigateFunction, booking: BookingEntity, editType: EditType) => {
	// Discard any in-progress alterations before editing
	await discardAlterations(navigate, {
		bookingIds: [booking.id],
		systemExpired: true,
	});

	// Check if booking can be modified
	const res = await checkBookingCanBeModified(booking.id);
	const canContinue = await ProcessResults(res, false);
	if (!canContinue) {
		return;
	}

	if (!booking.bookedSummary) {
		console.error('Booked summary missing for event booking');
		return;
	}

	// Check if booking has a discount applied - warn user
	const discounted = (booking.bookedSummary.discountAmount ?? 0) > 0;
	if (discounted) {
		try {
			await newConfirmModal(
				'This booking has a discount applied',
				'Editing this booking may affect the applied discount. Do you want to continue?',
				{
					confirmText: 'Continue',
					cancelText: 'Cancel',
				},
			);
		} catch {
			// User cancelled
			return;
		}
	}

	// Clear existing wizard data
	clearEventBookingWizardData();
	clearOldEventBookingWizardData();
	clearEventBookingTransactionIdFromStorage();

	// Convert booking to wizard data
	const wizardData = convertEventBookingToWizardData(booking);

	// Save to session storage
	saveEventBookingWizardDataToLocalStorage(wizardData);
	saveOldEventBookingWizardData(cloneDeep(wizardData));

	// Navigate to the event booking wizard tickets step
	// Event bookings go directly to tickets step regardless of edit type
	navigate('/event-booking-wizard/tickets');
};
